import { useEffect, useState } from 'react';
import ImportDraftService from '@/services/import-draft/import-draft-service';

export default function useInlineProcessing(): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    ImportDraftService.inlineProcessingEnabled().then(value => { if (active) setEnabled(value); });
    return () => { active = false; };
  }, []);

  return enabled;
}
